import api from "./api";
import { sendHttpRequest } from "../../../src/actions/actionCreators/httpActions";
import { showError } from "../../../src/actions/actionCreators/snackbarActions";
import * as actionTypes from "./actionTypes";

export const loadLogs = (filters, pager) => {
  return async dispatch => {
    dispatch({ type: actionTypes.LOAD_LOGS_STARTED, payload: {} });
    try {
      let logs = await dispatch(sendHttpRequest(api.getLogs(filters, pager)));
      dispatch({ type: actionTypes.LOAD_LOGS_SUCCEEDED, payload: { logs } });
    } catch (error) {
      dispatch({ type: actionTypes.LOAD_LOGS_FAILED, payload: { error } });
      dispatch(showError(error.message, error.correlationId));
    }
  };
};

const exportLogs = (filters, fileType) => {
  return dispatch => {
    return api.exportLogs(filters, fileType).catch(err => {
      dispatch(showError(err.message));
      throw err;
    });
  };
};

export const buildLogsExportDownloadUrl = (filters, fileType) => {
  return async dispatch => {
    try {
      let model = await dispatch(exportLogs(filters, fileType));
      let downloadLink = api.buildLogsExportDownloadUrl(model.filePath, model.fileName);
      dispatch({ type: actionTypes.LOAD_DOWNLOADPATH_SUCCEEDED, payload: { downloadLink } });
    } catch (error) {
      dispatch({ type: actionTypes.LOAD_DOWNLOADPATH_FAILED, payload: { error } });
      dispatch(showError(error.message, error.correlationId));
    }
  };
};

export const loadLevels = () => {
  return async (dispatch, getState) => {
    let { levels } = getState().logsData;
    if (levels.length > 0) return levels;

    try {
      let levels = await dispatch(sendHttpRequest(api.getLevels()));
      dispatch({ type: actionTypes.LOAD_LEVELS_SUCCEEDED, payload: { levels } });
    } catch (error) {
      dispatch({ type: actionTypes.LOAD_LEVELS_FAILED, payload: { error } });
      dispatch(showError(error.message, error.correlationId));
    }
  };
};

export const loadLogAccordingToLogId = logId => {
  return async (dispatch, getState) => {
    let log =
      getState().logsData.logs.values && getState().logsData.logs.values.find(x => x.id === Number.parseInt(logId));
    if (log) {
      dispatchAction(dispatch, actionTypes.LOAD_LOG_SUCCEEDED, { log });
      return;
    }

    dispatch({ type: actionTypes.LOAD_LOG_STARTED, payload: {} });
    try {
      let log = await dispatch(sendHttpRequest(api.getLogAccordingToLogId(logId)));
      dispatchAction(dispatch, actionTypes.LOAD_LOG_SUCCEEDED, { log });
    } catch (error) {
      dispatch({ type: actionTypes.LOAD_LOG_FAILED, payload: { error } });
      dispatch(showError(error.message, error.correlationId));
    }
  };
};

export const loadLogAccordingToCorrelationId = correlationId => {
  return async dispatch => {
    dispatch({ type: actionTypes.LOAD_LOG_STARTED, payload: {} });
    try {
      let log = await dispatch(sendHttpRequest(api.getLogAccordingToCorrelationId(correlationId)));
      dispatch({ type: actionTypes.LOAD_LOG_SUCCEEDED, payload: { log } });
    } catch (error) {
      dispatch({ type: actionTypes.LOAD_LOG_FAILED, payload: { error } });
      dispatch(showError(error.message, error.correlationId));
    }
  };
};

const dispatchAction = (dispatch, type, payload) => {
  dispatch({ type: type, payload });
};
